module.exports = __webpack_public_path__ + "img/China.270ae601.png";